import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { objectify, fetchPost } from '../../utils';

export const fetch = async (query: { ProductId: number; Warehouse: string; filters: any; LotSerial: any; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { ProductId, Warehouse, LotSerial, filters, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchPost(
    `/InventoryEnquiry/Product/${ProductId}/Warehouse/${Warehouse}/LotDetails/${LotSerial}/Picking`,
    filters,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        StockingLotAllocationPickings: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.StockingLotAllocationPickings) {

            return {
              records: result.StockingLotAllocationPickings.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
